import { render, staticRenderFns } from "./SistemaGrupoUsuariosEdit.vue?vue&type=template&id=ccc8d31a"
import script from "./SistemaGrupoUsuariosEdit.vue?vue&type=script&lang=js"
export * from "./SistemaGrupoUsuariosEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports